export * from './abteilungen.component';
export * from './abteilungen.component.module';